var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import '../../shared/css/Media.css';
import '../../shared/css/generic-styles.css';
import '../../shared/css/Stack.css';
import { Caption1, Caption2, Headline } from './Text';
import { HStack, VStack } from './Stack';
import { Space } from './Space';
import { useViewportSize } from './ProviderResponsive';
import { useThemeable } from './ProviderStyleAccess';
export var Media = function (props) {
    var caption = props.caption, _a = props.showCaption, showCaption = _a === void 0 ? false : _a, _b = props.aspectRatio, aspectRatio = _b === void 0 ? '' : _b, _c = props.size, size = _c === void 0 ? 'fill' : _c, wrapperStyle = props.wrapperStyle, className = props.className, children = props.children, profile = props.profile, alignCaption = props.alignCaption, _d = props.fallbackColor, fallbackColor = _d === void 0 ? 'text-primary' : _d;
    var spacingMode = useViewportSize().spacingMode;
    var space = useThemeable().space;
    var mediaStyles = {
        margin: spacingMode === 'normal'
            ? "".concat(space.vUnify + space.vExtra, "px ").concat(space.hUnify + space.hExtra, "px")
            : "".concat(space.vUnify, "px ").concat(space.hUnify, "px"),
    };
    var sizes = ['small', 'medium', 'large'];
    var isPredefinedSize = sizes.includes(size);
    var fallbackBackgroundColor = "rgba(var(--color-".concat(fallbackColor, "), .1)");
    var renderMedia = function () {
        var _a;
        var _b = props.type, type = _b === void 0 ? 'image' : _b, _c = props.imageSrc, imageSrc = _c === void 0 ? '' : _c, style = props.style;
        if (type === 'video' && 'videoSrc' in props) {
            // TypeScript knows this is VideoMediaProps
            return (_jsxs("video", { poster: imageSrc, className: "media-graphic ".concat(className), autoPlay: props.autoPlay, loop: props.loop, controls: props.showControls, muted: props.muted, playsInline: true, style: style, children: [(_a = props.videoSrc) === null || _a === void 0 ? void 0 : _a.map(function (url, index) { return (_jsx("source", { src: url, type: "video/mp4" }, index)); }), "Your browser does not support the video tag."] }));
        }
        if (type === 'image' && imageSrc) {
            // TypeScript knows this is ImageMediaProps
            return (_jsx("img", { className: "media-graphic ".concat(className), style: style, src: imageSrc, alt: caption }));
        }
        return null; // If no valid media type is found
    };
    return (_jsxs("div", { style: __assign(__assign({}, mediaStyles), wrapperStyle), className: "v-stack height-hug ".concat(size === 'fill' ? 'width-fill' : ''), children: [_jsxs("div", { style: {
                    width: size === 'fill' ? '100%' : isPredefinedSize ? '' : size,
                    aspectRatio: aspectRatio,
                }, className: "media-clip media-size ".concat(isPredefinedSize ? ' ' + size : size === 'fill' ? 'width-fill' : '', " ").concat(profile ? 'profile' : '', " ").concat(className ? className : ''), children: [!props.imageSrc && (_jsx(HStack, { align: "middle center", className: "media-graphic fallbackColor", style: {
                            backgroundColor: fallbackBackgroundColor
                        }, children: _jsx(Headline, { align: "center", width: "hug", className: "color-".concat(fallbackColor), children: children }) })), renderMedia()] }), showCaption &&
                _jsxs(VStack, { className: "media-size ".concat(isPredefinedSize ? size : '', " ").concat(alignCaption, " "), style: { width: !isPredefinedSize ? size : '', }, children: [_jsx(Space.Content, {}), size === 'small' && _jsx(Caption2, { align: alignCaption, className: "v-stack media-caption ".concat(alignCaption), children: caption }), size !== 'small' && _jsx(Caption1, { align: alignCaption, className: "v-stack media-caption ".concat(alignCaption), children: caption })] })] }));
};
